import React, { useEffect, useState } from 'react'
import { convertLocalDate } from '../../Utils/configController';
import DataTable from '../../components/Common/DataTable';
import * as url from '../../helpers/url_helper';
import $ from 'jquery'
import { useParams } from 'react-router-dom';

const DebugDetail = () => {
    const { macAddress } = useParams()
    const [loading, setLoading] = useState(false);
    const [dataTableId, setDataTableId] = useState(null);
    const [isReload, setReload] = useState(false);
    console.log("isReload", isReload);

    const reloadDataTable = () => {
        console.log("dataTableId", dataTableId);

        if (dataTableId) {
            const dataTableInstance: any = $(`#${dataTableId}`).DataTable();
            dataTableInstance.ajax.reload(null, false);
        }
    };

    // useEffect(() => {
    //     // reloadDataTable();
    //     console.log("sdfdjbfdhfbghdfg", isReload);
    //     if (isReload) {
    //         console.log("sdfdjbfdhfbghdfg", isReload);

    //         const interval = setInterval(() => {
    //             reloadDataTable()
    //         }, 3000)
    //         return () => clearInterval(interval);
    //     }
    // }, [dataTableId, isReload])

    const handleDataTableIdChange = (dataTableId: any) => {
        // Now you have access to the DataTable ID here
        //   console.log('DataTable ID:', dataTableId);
        setDataTableId(dataTableId)
        // You can do whatever you need with the ID in this component
    };

    const columns = [
        {
            title: "Topic",
            render: function (data: any, type: any, row: any) {
                return row?.topic ? `<div> 
                <div>${row.topic}</div>
              </div>` : "-"
            }
        },
        {
            title: 'PCB',
            className: 'pcb-column',
            render: function (data: any, type: any, row: any) {
                if (row?.topic && row?.topic.includes("/Tx")) {
                    try {
                        // Parse and pretty print
                        const parsedCommand = JSON.parse(row?.command);
                        const formatted = JSON.stringify(parsedCommand, null, 2);

                        return `<pre>${formatted}</pre>`;
                    } catch (error) {
                        // If parsing fails, show raw string
                        return `<pre>${row?.command}</pre>`;
                    }
                }
                return "-";
            }
        },
        {
            title: 'Mobile / Server',
            className: 'pcb-column',
            render: function (data: any, type: any, row: any) {
                if (row?.topic && row?.topic.includes("/Rx")) {
                    try {
                        // Parse and pretty print
                        const parsedCommand = JSON.parse(row?.command);
                        const formatted = JSON.stringify(parsedCommand, null, 2);

                        return `<pre>${formatted}</pre>`;
                    } catch (error) {
                        // If parsing fails, show raw string
                        return `<pre>${row?.command}</pre>`;
                    }
                }
                return "-";
            }
        },
        {
            title: 'Created At',
            render: function (data: any, type: any, row: any) {
                return row?.createdAt ? `<div> 
                <div>${convertLocalDate(row.createdAt)}</div>
              </div>` : "-"
                // return row?.createdAt
                //     ? convertLocalDate(row.createdAt) : "-"
            }
        },
        // {
        //     title: 'Actions',
        //     render: function () {
        //         return (
        //             `<div class="d-flex gap-2">
        //                         <button class="delete-btn" style="border: none; outline: none; background: none;">
        //                             <i class="bx bx-trash-alt" style="font-size: 20px;"></i>
        //                         </button>
        //                         <button class="log-btn" style="border: none; outline: none; background: none;"><span class="badge bg-dark" style="height: 25px; width: 60px; font-size: 12px; padding: 6px;">Details</span></button>
        //                     </div>`
        //         );
        //     }
        // }
    ]

    return (
        <>
            <DataTable
                // data={servicePersonList}
                apiURL={`${url.BASE_URL}${url.DEBUG_DETAIL_LIST}`}
                paramsId={{ macAddress: macAddress }}
                columns={columns}
                isAddBtnShow={false}
                onDataTableRefresh={handleDataTableIdChange}
                idName={"DebugDeviceDetails"}
                isEntryShow={true}
                isClicked={true}
                setReload={setReload}
            />
        </>
    )
}

export default DebugDetail